var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-8 text-center"},[_c('div',{staticClass:"font-weight-bold opacity-70 mb-8"},[_vm._v(" Scroll up to complete the previous steps before starting this one. ")]),_c('v-btn',_vm._b({on:{"click":function($event){return _vm.$emit('back')}}},'v-btn',_vm.smallButton,false),[_vm._v("Go Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }